import React, { FC } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface IRefundRepairDialogProps {
  handleRefund: VoidFunction;
  handleClose: VoidFunction;
  isLoading: boolean;
  open: boolean;
}

const RefundRepairDialog: FC<IRefundRepairDialogProps> = ({
  handleRefund,
  handleClose,
  isLoading,
  open,
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Refund Repair</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to refund this completed repair?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
        >
          No
        </Button>
        <Button
          color="error"
          disabled={isLoading}
          onClick={handleRefund}
        >
          Yes, Refund
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RefundRepairDialog;